define(['underscore', 'text!./templates/number-incrementer.html'],
    (_, templateStr) => {

        return [function () { // NOSONAR angular js
            return {
                restrict: 'E',
                template: templateStr,
                scope: {
                    /** Model (value) to select. */
                    model: '=',
                    /** min value possible*/
                    minValue: '=',
                    /** max value possible*/
                    maxValue: '=',
                    /** initial value */
                    initialValue: '=',
                    /** step per click*/
                    step: '=',
                    /** is field readonly*/
                    disabled: '=',
                },
                link: function ($scope) { // NOSONAR angualr js
                    if ($scope.disabled) {

                        const minusDivs = document.getElementsByClassName('minus');
                        //set attribut and classes when last number incrementer loads
                        if (minusDivs.length === 3) {
                            for (let i = 0; i < minusDivs.length; i++) {
                                minusDivs[i].setAttribute('read-only', true);
                                minusDivs[i].className += ' readonly';

                            }
                        }

                        const plusDivs = document.getElementsByClassName('plus');
                        //set attribut and classes when last number incrementer loads
                        if (plusDivs.length === 3) {
                            for (let j = 0; j < plusDivs.length; j++) {
                                plusDivs[j].setAttribute('read-only', true);
                                plusDivs[j].className += ' readonly';
                            }
                        }
                    }

                    if ($scope.model === undefined || $scope.model === null) {
                        //parseInt needed to make sure it is not String operation
                        $scope.model = parseInt($scope.initialValue);
                    }

                    $scope.minusClicked = function () {
                        if (($scope.model > $scope.minValue) && !$scope.disabled) {
                            //parseInt needed to make sure it is not String operation
                            $scope.model = parseInt($scope.model) - $scope.step;
                        }
                    };

                    $scope.plusClicked = function () {
                        if (($scope.model < $scope.maxValue) && !$scope.disabled) {
                            //parseInt needed to make sure it is not String operation
                            $scope.model = parseInt($scope.model) + $scope.step;
                        }

                    };

                },
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/NumberIncrementer.js